import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Text from '@atlaskit/primitives/text';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

interface Props {
	onUndoReleasedProjectKeys: () => void;
}

const WarningSection = ({ onUndoReleasedProjectKeys }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={sectionWrapperStyles}>
			<SectionMessage
				title="You're about to delete previous project keys"
				appearance="warning"
				actions={[
					<SectionMessageAction
						key="more"
						href="https://support.atlassian.com/jira-software-cloud/docs/edit-a-projects-details/"
					>
						{formatMessage(messages.moreInfoLabel)}
					</SectionMessageAction>,
					<SectionMessageAction key="undo" onClick={onUndoReleasedProjectKeys}>
						{formatMessage(messages.undoLabel)}
					</SectionMessageAction>,
				]}
			>
				<Text>{formatMessage(messages.warningLabel)}</Text>
			</SectionMessage>
		</Box>
	);
};

export default WarningSection;

const sectionWrapperStyles = xcss({
	marginTop: 'space.250',
});
